import { useTranslation } from "react-i18next";

export default function TestimonialSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-10 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="relative bg-foreground-950 rounded-3xl overflow-hidden">
          {/* Decorative element */}
          <div className="absolute -top-6 left-8 w-16 h-24 border-l-2 border-b-2 border-accent-400/40 rounded-bl-3xl hidden md:block"></div>

          <div className="grid grid-cols-1 md:grid-cols-2">
            {/* Left: Portrait */}
            <div className="relative h-[300px] md:h-auto">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20Polish%20man%20in%20his%20late%2020s%20with%20light%20stubble%20wearing%20a%20tailored%20olive%20linen%20shirt%2C%20leaning%20against%20a%20minimalist%20concrete%20wall%20in%20a%20modern%20loft%20interior%2C%20arms%20crossed%20with%20confident%20yet%20approachable%20expression%2C%20natural%20window%20light%20creating%20soft%20Rembrandt%20style%20shadows%20across%20his%20face%2C%20editorial%20fashion%20portrait%2C%20warm%20muted%20earth%20tones%2C%20shallow%20depth%20of%20field%2C%20premium%20lifestyle%20photography&width=800&height=1000&seq=kakobuy-testimonial-v2&orientation=portrait"
                alt="Michał Kowalski - ekspert zakupowy"
                title="Michał Kowalski – ekspert zakupowy z Chin"
                className="w-full h-full object-cover object-center"
              />
              {/* Overlay for blend */}
              <div className="absolute inset-0 bg-gradient-to-r from-transparent to-foreground-950/20 md:bg-gradient-to-r md:from-transparent md:to-foreground-950"></div>
            </div>

            {/* Right: Testimonial Text */}
            <div className="flex flex-col justify-center px-8 md:px-12 py-10 md:py-14">
              <span className="font-heading text-7xl md:text-8xl text-accent-300/30 leading-none mb-4 select-none">
                &ldquo;
              </span>
              <blockquote className="text-base md:text-lg text-background-50/90 leading-relaxed mb-6 font-light">
                {t("testimonial.quote")}
              </blockquote>
              <div className="mb-8">
                <p className="text-sm font-semibold text-background-50">
                  {t("testimonial.name")}
                </p>
                <p className="text-xs text-background-50/50">
                  {t("testimonial.role")}
                </p>
              </div>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-accent-400/60 text-sm font-medium text-accent-400 hover:bg-accent-400/10 transition-all cursor-pointer whitespace-nowrap w-fit"
              >
                {t("testimonial.cta")}
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}